import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { TemplateResult } from "lit";

/**
 * Render trusted HTML (icons/known constants). Do NOT pass untrusted/user content.
 * - Strings are treated as trusted and rendered via unsafeHTML.
 * - TemplateResult is passed through unchanged.
 * @param content Trusted string (from internal sources) or TemplateResult
 * @returns Lit directive/TemplateResult, or "" when no content
 */
export function handleUnsafeHtml(
  content?: string | TemplateResult,
): TemplateResult | ReturnType<typeof unsafeHTML> | string {
  if (!content) return "";

  return typeof content === "string" ? unsafeHTML(content) : content;
}
